import { Check, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading, Accent } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";
import { scrollToId } from "@/lib/api";

export const Pricing = () => {
  const { t, c } = useLang();
  return (
    <section id="pricing" data-testid="pricing-section" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-36">
      <SectionHeading kicker={t.pricing.kicker} title={<Accent parts={t.pricing.title} />} testid="pricing-heading" />

      <div className="grid md:grid-cols-3 gap-6 md:gap-8 items-stretch">
        {c.PRICING.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.1} className="h-full">
            <article
              data-testid={p.testid}
              className={`relative h-full border p-8 md:p-10 flex flex-col transition-[transform,border-color] duration-500 hover:-translate-y-1 ${
                p.featured ? "border-gold bg-gold/[0.05]" : "border-line bg-ink hover:border-gold/40"
              }`}
            >
              {p.featured && (
                <span className="absolute -top-3 left-8 bg-gold text-ink font-mono text-[11px] uppercase tracking-[0.2em] px-3 py-1">
                  {t.pricing.featured}
                </span>
              )}
              <h3 className="font-serif text-3xl text-mist mb-2">{p.name}</h3>
              <p className="text-dim text-sm mb-8">{p.desc}</p>
              <p className="mb-8">
                <span className="font-mono text-3xl md:text-4xl text-gold">{p.price}</span>
                {p.period && <span className="text-dim text-sm ml-2">{p.period}</span>}
              </p>
              <ul className="flex-1 flex flex-col gap-3 mb-10">
                {p.features.map((f, j) => (
                  <li key={j} className="flex items-start gap-3 text-sm text-dim">
                    <Check size={15} className="text-gold mt-0.5 shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`pricing-cta-${p.id}`}
                onClick={() => scrollToId("#contact")}
                className={`group inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm tracking-wide transition-colors duration-300 ${
                  p.featured ? "bg-gold text-ink hover:bg-gold-light" : "border border-line text-mist hover:border-gold hover:text-gold"
                }`}
              >
                {t.pricing.cta}
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="text-dim/70 text-xs md:text-sm mt-10 max-w-2xl">{t.pricing.note}</p>
      </Reveal>
    </section>
  );
};
